<template>
  <span>
    Subscription changed from
    <strong>{{ eventLog.existingPlan }}</strong> to
    <strong>{{ eventLog.currentPlan }}</strong>
  </span>
</template>
<script>
export default {
  name: 'recentActivityTableDescriptionSubscriptionChanged',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
